// src/experiments/flags.config.js
//
// Feature flags: plain switches with a code default and an optional remote
// override, read with getFlag() / useFlag() from src/experiments/flags.js.
// Unlike an experiment, a flag applies to everyone, crawlers included, fires
// no exposure, is not stamped into analytics and has no session freeze. Use a
// flag for a kill switch or a staged feature; use an experiment to measure.
//
// A remote value must have the same type as the default here (boolean,
// number or string). Unknown remote keys are ignored. Remove a flag by
// deleting it here and, if it was set, in the console.
export const FLAGS = {
  // SMS delivery of the one-time password, and with it the sign-in entry
  // point in the app bar. Read through ENABLE_OTP_SMS in
  // questionEngineOtpHelpers.js, and held (see below) because it gates UI
  // that would otherwise paint before the remote value arrives.
  otp_sms: true,
  // The lean car journey: the car and returning-user flows stop asking what
  // the vehicle is used for and quote personal use, and the car results page
  // drops the Excess filter. The question JSON marks what it changes; see
  // src/experiments/questionFlags.js. Not held: nothing reads it on first
  // paint. The engine reads it when it loads a step and when the flow is
  // submitted, and the results page when it mounts.
  car_lean_flow: true,
};

// Flags that gate something a visitor can see or click on first paint.
// `useFlag()` returns `undefined` for these until the value is settled, so
// the dependent UI renders nothing rather than appearing on the code default
// and then vanishing when the remote document lands. Settled means: the
// cached document applied, the boot fetch returned, or the hold budget
// elapsed — whichever comes first, so a blocked fetch still fails open to
// the code default.
//
// Add a flag here whenever its value decides whether something renders.
// Leave it out when the flag only affects behaviour nobody can see (which
// endpoint to call, whether to attempt a send): those apply as soon as they
// arrive, with nothing to flicker.
export const HOLD_FLAGS = ['otp_sms'];
